/* Product page behaviour — no dependencies, progressive enhancement.
   Everything here is an upgrade: with JS off, the form still submits,
   the gallery still shows the featured image, quantity is still typeable. */
(function () {
  'use strict';

  /* ---- Gallery: thumbnails swap the main image ------------------------- */
  document.querySelectorAll('.tih-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.tih-gallery__main img');
    if (!main) return;

    gallery.addEventListener('click', function (e) {
      var thumb = e.target.closest('.tih-gallery__thumb');
      if (!thumb) return;

      var full = thumb.getAttribute('data-full');
      if (full) {
        main.src = full;
        main.removeAttribute('srcset');
      }
      gallery.querySelectorAll('.tih-gallery__thumb').forEach(function (t) {
        t.classList.toggle('is-active', t === thumb);
      });
    });
  });

  /* ---- Quantity steppers ---------------------------------------------- */
  document.querySelectorAll('.tih-qty').forEach(function (widget) {
    var input = widget.querySelector('.tih-qty__input');
    if (!input) return;

    widget.addEventListener('click', function (e) {
      var btn = e.target.closest('.tih-qty__btn');
      if (!btn) return;

      var step = parseInt(btn.getAttribute('data-step'), 10) || 0;
      var next = (parseInt(input.value, 10) || 1) + step;
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---- Variant picker --------------------------------------------------
     The size chips are radio buttons, and radio buttons submit nothing the cart understands: the form sends its
     hidden "id", which was set once, on page load, to the variant the page was drawn with. Choosing XL therefore put
     the first size in the basket, on every product with sizes. This finds the variant the chosen options make,
     sets the id, and brings the price, the stock line, the buttons and the address in step with it.
     Everything about a variant comes from the page's own variant data, so what is shown here is what the server
     would have drawn for that size. */
  (function () {
    var form = document.getElementById('tih-add-to-cart');
    var dataEl = document.querySelector('script[type="application/json"][id^="tih-variants-"]');
    if (!form || !dataEl) return;
    var fieldsets = form.querySelectorAll('.tih-option');
    if (!fieldsets.length) return;                            // a product with one variant has nothing to pick

    var variants = JSON.parse(dataEl.textContent);
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('.tih-pdp__atc');
    var price = document.querySelector('.tih-pdp__price');
    var stock = document.querySelector('.tih-pdp__stock');
    var express = form.querySelector('.tih-pdp__express');
    var bar = document.querySelector('.tih-stickybar');
    var barBtn = bar && bar.querySelector('.tih-stickybar__btn');
    var barPrice = bar && bar.querySelector('.tih-stickybar__price');

    function chosen() {
      return Array.prototype.map.call(fieldsets, function (fs) {
        var on = fs.querySelector('input:checked');
        return on ? on.value : null;
      });
    }
    function match(options) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === options[i]; });
      });
    }
    function setButton(btn, available) {
      if (!btn) return;
      btn.disabled = !available;
      btn.textContent = available ? btn.getAttribute('data-label-add') : btn.getAttribute('data-label-out');
    }

    function sync(fromChoice) {
      var options = chosen();
      var found = match(options)[0];

      // A size that is sold out (in the colour or fit already chosen) is shown as such, but stays choosable, so the
      // customer sees "sold out" for it rather than a chip that does nothing.
      fieldsets.forEach(function (fs, i) {
        fs.querySelectorAll('.tih-option__input').forEach(function (input) {
          var trial = options.slice(); trial[i] = input.value;
          var chip = input.nextElementSibling;
          if (chip) chip.classList.toggle('is-soldout', !match(trial).some(function (v) { return v.available; }));
        });
      });

      if (!found) {                                           // a combination the shop does not make
        setButton(atc, false); setButton(barBtn, false);
        if (express) express.hidden = true;
        return;
      }
      idInput.value = found.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));   // the express-checkout button listens for this
      if (price) price.innerHTML = found.priceHtml;
      if (stock) stock.innerHTML = found.stockHtml;
      if (barPrice) barPrice.textContent = found.priceText;
      setButton(atc, found.available); setButton(barBtn, found.available);
      if (express) express.hidden = !found.available;
      if (fromChoice && window.history && history.replaceState) {   // a reload, or a shared link, keeps the size (only once somebody has chosen)
        var url = new URL(window.location.href);
        url.searchParams.set('variant', found.id);
        history.replaceState(null, '', url.toString());
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.classList && e.target.classList.contains('tih-option__input')) sync(true);
    });
    sync();
  })();

  /* ---- Sticky buy bar --------------------------------------------------
     Shows only once the real Add-to-cart button has scrolled out of view,
     so it never competes with the button it mirrors. */
  var bar = document.querySelector('.tih-stickybar');
  var atc = document.querySelector('.tih-pdp__atc');
  var form = document.getElementById('tih-add-to-cart');

  if (bar && atc && 'IntersectionObserver' in window) {
    bar.hidden = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -80px 0px', threshold: 0 }
    );
    observer.observe(atc);

    var barBtn = bar.querySelector('.tih-stickybar__btn');
    if (barBtn && form) {
      barBtn.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.submit();
        }
      });
    }
  }
})();
